<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_evt"
      persistent
      :max-width="width"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pb-0 px-1" v-if="inventory">
          <v-container v-if="type === 'del'">
            <p class="default_txt text-center">Are you sure?</p>
            <div class="d-flex justify-center mt-2 pb-5">
              <v-btn
                class="text-capitalize rounded-lg mr-3 pa-6"
                depressed
                dark
                outlined
                color="#006341"
                @click="$emit('close')"
                >Cancel</v-btn
              >
              <v-btn
                class="bg_default text-capitalize rounded-lg pa-6"
                depressed
                dark
                @click="postData"
                >Delete</v-btn
              >
            </div>
            <div style="height: 30px"></div>
          </v-container>
          <v-container style="height: max-content" v-else>
            <v-row>
              <v-col cols="12">
                <p class="small_txt grey--text">Title</p>
                <v-text-field
                  class="mt-2 rounded-lg"
                  dense
                  v-model="inventory.body.title"
                  placeholder="Type here"
                  hide-details
                  color="green"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <p class="small_txt grey--text">Start Date</p>
                <v-menu
                  v-model="date1"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="inventory.body.start_date"
                      prepend-inner-icon="mdi-calendar-range"
                      readonly
                      dense
                      color="green"
                      hide-details
                      v-on="on"
                      placeholder="Click here"
                      class="rounded-lg"
                    ></v-text-field>
                  </template>
                  <div>
                    <v-date-picker
                      v-model="inventory.body.start_date"
                    ></v-date-picker>
                  </div>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <p class="small_txt grey--text">Start Time</p>
                <v-menu
                  ref="menu1"
                  v-model="time1"
                  :close-on-content-click="false"
                  :return-value.sync="inventory.body.start_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="inventory.body.start_time"
                      placeholder="Click Here"
                      append-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      dense
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="time1"
                    v-model="inventory.body.start_time"
                    full-width
                    @click:minute="$refs.menu1.save(inventory.body.start_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <p class="small_txt grey--text">End Date</p>
                <v-menu
                  v-model="date2"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="inventory.body.end_date"
                      prepend-inner-icon="mdi-calendar-range"
                      readonly
                      :disabled="!inventory.body.start_date"
                      dense
                      color="green"
                      hide-details
                      v-on="on"
                      placeholder="Click here"
                      class="rounded-lg"
                    ></v-text-field>
                  </template>
                  <div>
                    <v-date-picker
                      v-model="inventory.body.end_date"
                    ></v-date-picker>
                  </div>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <p class="small_txt grey--text">End Time</p>
                <v-menu
                  ref="menu2"
                  v-model="time2"
                  :close-on-content-click="false"
                  :return-value.sync="inventory.body.end_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="inventory.body.end_time"
                      :disabled="!inventory.body.start_date"
                      placeholder="Click Here"
                      append-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      dense
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="time2"
                    v-model="inventory.body.end_time"
                    full-width
                    @click:minute="$refs.menu2.save(inventory.body.end_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <p class="small_txt grey--text">Description</p>
                <v-textarea
                  class="mt-2 rounded-lg"
                  v-model="inventory.body.description"
                  rows="3"
                  placeholder="Type here"
                  color="green"
                  dense
                  hide-details
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <p class="small_txt grey--text">Additional Info</p>
                <v-textarea
                  class="mt-2 rounded-lg"
                  v-model="inventory.body.additional_info"
                  rows="3"
                  placeholder="Type here"
                  color="green"
                  dense
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="#006341"
            ></v-progress-circular>
            <b class="color_default">Loading...</b>
          </v-overlay>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="type !== 'del'"
            depressed
            color="var(--g)"
            dark
            class="text-capitalize"
            @click="postData"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  components: {},
  name: "evtupdialog",
  data() {
    return {
      loading: false,
      date1: false,
      time1: false,
      date2: false,
      time2: false,
    };
  },
  props: ["d_evt", "title", "type", "width", "inventory"],
  methods: {
    postData() {
      this.loading = true;
      let data = {
        path: this.inventory.path,
        body: this.inventory.body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          for (let i in this.inventory.body) {
            this.inventory.body[i] = "";
          }
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("close");
          this.$emit("refetch");
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.dot_out {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background: green; */
}
.line_graph {
  width: 2px;
  /* background: green; */
  height: 100%;
  margin-top: -5px;
}
</style>
